import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, developerOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="flex flex-col items-center gap-3">
                    <div className="h-10 w-10 rounded-full border-4 border-brand-green border-t-transparent animate-spin" />
                    <p className="text-sm text-muted-foreground">Memuat...</p>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (developerOnly && user.role !== "developer") return <Navigate to="/dashboard" replace />;
    if (adminOnly && !["admin", "super_admin", "developer"].includes(user.role)) return <Navigate to="/dashboard" replace />;
    return children;
}
